function e(e){var{aud:r,sub:s,exp:u}=JSON.parse(atob(e.split(".")[1]));return{userRoles:r,userId:s,expired:u}}export{e as parseAccessToken};
//# sourceMappingURL=parse-access-token.js.map
